import React from "react";
import { Progress } from "antd";
import { UserOutlined } from "@ant-design/icons";
import "./style.scss";
import Tag from "components/BaseWidgets/tag";
import { WhitePremiumIcon } from "assets/icons";
import { usePremium } from "context/PremiumContext";
import Avatar from "components/BaseWidgets/Avatar";

const ProgressAvatar = ({ profileData, isLoading }) => {
  const { isPremium } = usePremium();
  return (
    <div className="progress-avatar">
      <Progress
        type="circle"
        percent={
          profileData?.profile_completion_data?.profile_completion_percent
        }
        strokeWidth={3}
        size={84}
        strokeColor="#672666"
        trailColor="#EBE9EB"
        format={() => ""}
      />
      <div className="profile-status">
        {isPremium && (
          <div className="premium-profile">
            <WhitePremiumIcon />
          </div>
        )}
      </div>
      <span className="avatar-image-wrapper">
        <Avatar
          url={profileData?.user_image}
          icon={<UserOutlined />}
          size={72}
          isLoading={isLoading}
        />
      </span>
      <Tag variant="yellow" className="progress-avatar-tag">
        {profileData?.profile_completion_data?.profile_completion_percent}%
      </Tag>
    </div>
  );
};

export default ProgressAvatar;
